// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attribute-custom-button {
  background-color: #b99278 !important;
  border-color: #b99278 !important;
  color: white !important;
}

.attribute-custom-button:hover {
  background-color: #6b3f4f !important;
  border-color: #6b3f4f !important;
}

.attribute-custom-button-text {
  color: white !important;
}

.attribute-ok-button {
  background-color: #dc3545 !important;
  border-color: #dc3545 !important;
  color: white !important;
}

.attribute-ok-button:hover {
  background-color: #bb2d3b !important; /* hover hone pe color change */
  border-color: #bb2d3b !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Attributes.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC,EAAE,+BAA+B;EACrE,gCAAgC;AAClC","sourcesContent":[".attribute-custom-button {\n  background-color: #b99278 !important;\n  border-color: #b99278 !important;\n  color: white !important;\n}\n\n.attribute-custom-button:hover {\n  background-color: #6b3f4f !important;\n  border-color: #6b3f4f !important;\n}\n\n.attribute-custom-button-text {\n  color: white !important;\n}\n\n.attribute-ok-button {\n  background-color: #dc3545 !important;\n  border-color: #dc3545 !important;\n  color: white !important;\n}\n\n.attribute-ok-button:hover {\n  background-color: #bb2d3b !important; /* hover hone pe color change */\n  border-color: #bb2d3b !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
